import { keyframes } from './stitches.config';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function callAll(...fns) {
    return function callAllFns() {
        // eslint-disable-next-line prefer-rest-params
        const arg = arguments;
        fns.forEach(
        // eslint-disable-next-line prefer-spread, @typescript-eslint/no-explicit-any
        (fn) => typeof fn === 'function' && fn.apply(null, arg));
    };
}
export const pulse = keyframes({
    '0%, 100%': {
        opacity: 1,
    },
    '50%': {
        opacity: 0.5,
    },
});
//# sourceMappingURL=lib.js.map